import type { MandeError } from 'mande'
import { BadReqeustException, ForbiddenException, InvalidTOTPCodeException, MFANotSetupException, MFARequiredException, NotFoundException, ThrottledException, UnauthenticatedException, ValidationException } from '~/types/exceptions'

type Return = MandeError | UnauthenticatedException | ValidationException | ForbiddenException | InvalidTOTPCodeException | MFANotSetupException | MFARequiredException

interface forbiddenMessage {
  message: string
}

export default function useHttpError(error: MandeError): Return {
  switch (error.response.status) {
    case 400:
      return new BadReqeustException()
    case 401:
      return new UnauthenticatedException()
    case 403:
      return handleForbidden(error)
    case 404:
      return new NotFoundException()
    case 422:
      return new ValidationException(error.body)
    case 429:
      return new ThrottledException()
    default:
      return error
  }
}

function handleForbidden(error: MandeError): Return {
  const msg = error.body as forbiddenMessage
  switch (msg.message) {
    case 'invalid code':
      return new InvalidTOTPCodeException()
    case 'mfa required':
      return new MFARequiredException()
    case 'mfa not setup':
      return new MFANotSetupException()
    default:
      console.log('unhandled 403 excpetion')
      console.log(msg)
  }
  return new ForbiddenException()
}
